import * as eventSelectors from '../../Containers/Events/selectors';
import * as notificationRoutines from './notificationsRoutines';
import * as paths from '../../Providers/paths';
import * as rootSelectors from '../../selectors/root';
import * as notificationSelectors from './notificationSelectors';
import * as ui_actions from '../../redux/ui/actions';
import * as userRoutines from '../../sagas/routines/userRoutines';
import { call, cancel, fork, put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { rsf } from '../../globals/firebase';
import { sendNotification } from '../../services/functionsApi';
import moment from 'moment';
import axios from "axios";
import config from '../../globals/config'
import {getCCValues} from "../../services/localStorage";

function* createNotificationSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const { notification } = action.payload;
    //Populate recipients object
    const r = {}
    //Converts recipients array to object
    notification.recipients.forEach(obj => {
        r[obj.id] = obj.name
    })
    const payload = {
        ...action.payload.notification,
        recipientsObj:  r,
        timestamp: Date.now(),
        type: 'broadcast'
    };

    try {
        //Create node in FB to store data for this notification
        let notification_id = yield call(
            rsf.database.create,
            paths.moduleData(activeEvent, 'peerToPeer', 'pushNotifications', 'data'),
            payload,
        );
        yield put(ui_actions.setActiveNotification(notification_id)); //Make the current notification the "active notification" as far as the app is concerned
        yield put(notificationRoutines.sendNotifications.trigger({...payload, notification_id})); //Kicks off the sending of the notifications
        yield put(notificationRoutines.createNotification.success());
        yield put(userRoutines.clearExtractedUsers.trigger());
    } catch (error) {
        yield put(notificationRoutines.createNotification.failure(error));
    }

}

//ATTEMPTS TO SEND TO EVERY RECIPIENT IN AN EVENT
function* sendNotificationsSaga(action) {
    // console.info("Starting sendNotificationsSaga", new Date())
    const notification = action.payload
    notification.recipients =  Object.keys(notification.recipientsObj)
    try {
        if(notification.recipients.length > 0 ) {
            yield put(notificationRoutines.sendNotification(notification))
            yield put(notificationRoutines.sendNotifications.success());
        }
    } catch (error) {
        yield put(notificationRoutines.sendNotifications.failure(error));
    }

}


//SENDS NOTIFICATION TO A PARTICULAR USER

function* sendNotificationSaga(action) {

    let poolId;
    //If non Membersuite event, we want to grab the poolId
     poolId = yield select(eventSelectors.makePoolId);

    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const notificationPayload = action.payload.notification;
    const { recipients, isSilent, senderUserId, text, deeplinkingCategory, discoverCardPath } = action.payload                            ;
    try {
        // yield put(notificationRoutines.updateRecipientStatus({ notification_id: id, recipient, status: 'sending' }));
        yield call(sendNotification, activeEvent, senderUserId, recipients, text, isSilent, poolId, deeplinkingCategory, discoverCardPath);
        //If not silent and inbox is selected, let's also send a silent one
        if(!isSilent && deeplinkingCategory === 'inbox'){
            yield call(sendNotification, activeEvent, senderUserId, recipients, text, true, poolId, deeplinkingCategory, discoverCardPath);
        }
        yield put(notificationRoutines.sendNotification.success());
        // yield put(notificationRoutines.updateRecipientStatus({ notification_id: id, recipient, status: 'sent' }));
    } catch (error) {
        // yield put(notificationRoutines.updateRecipientStatus({ notification_id: id, recipient, status: 'error' }));
        yield put(notificationRoutines.sendNotification.failure(error));
    }

}

function getStatsForPushNotificationByDate(event_id, date){
    const user_id = getCCValues().CC_USER_ID;

    return axios.get(`${config.REACT_APP_FB_FUNCTIONS_NOTIFICATIONS_HOST}/getPushNotificationStats?eventId=${event_id}&date=${date}`, {
            headers: {
                'User-id': user_id,
                'Authorization': ''
            }
        }
    )
}
function* getStatsForNotification(action) {
    try {
        const activeEvent = yield select(rootSelectors.selectActiveEventId);
        const activeNotification = yield select(notificationSelectors.selectActiveNotification);
        const date = moment(activeNotification.timestamp).format('YYYY-MM-DD')
        const res = yield call(getStatsForPushNotificationByDate, activeEvent, date);
        yield put(notificationRoutines.getStatsForPushNotifications.success(res.data));
    } catch (error) {
        yield put(notificationRoutines.getStatsForPushNotifications.failure(error));
    }

}

export function* syncNotificationsSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleData(activeEvent, 'peerToPeer', 'pushNotifications'), {
        successActionCreator: notificationRoutines.syncNotifications.success,
        failureActionCreator: notificationRoutines.syncNotifications.failure,
    });
}

export function* resetNotificationsSync() {
    yield put(notificationRoutines.stopSyncingNotifications.trigger());
    yield put(notificationRoutines.syncNotifications());
}

export default function* rootSaga() {
    yield takeEvery(notificationRoutines.createNotification.TRIGGER, createNotificationSaga);
    yield takeEvery(notificationRoutines.sendNotifications.TRIGGER, sendNotificationsSaga); //To begin the batch
    yield takeEvery(notificationRoutines.sendNotification.TRIGGER, sendNotificationSaga); //Listens for attempt to send a particular notificaation to a particular recipient
    yield takeLatest(notificationRoutines.getStatsForPushNotifications, getStatsForNotification); //Listens for attempt to send a particular notificaation to a particular recipient


    while (yield take(notificationRoutines.syncNotifications.TRIGGER)) {
        const bgNotificationsSync = yield fork(syncNotificationsSaga);
        yield take(notificationRoutines.stopSyncingNotifications.TRIGGER);
        yield cancel(bgNotificationsSync);
    }
}
